import { NavigationEnd, Router } from '@angular/router';
import { EnvironmentProviders, inject, provideEnvironmentInitializer } from '@angular/core';
import { LocationStrategy } from '@angular/common';

export const provideDisableBackButton = (): EnvironmentProviders => {
  return provideEnvironmentInitializer(() => {
    const locationStrategy = inject(LocationStrategy);
    const router = inject(Router);

    const setHistoryState = (): void => {
      window.history.pushState(null, '', window.location.href);
    };

    // Previene la possibilità di tornare indietro
    setHistoryState();
    // Controlla se vengono premuti i pulsanti avanti/indietro.
    locationStrategy.onPopState(() => {
      setHistoryState();
    });
    // Aggiorna la cronologia del browser a ogni cambio di rotta
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setHistoryState();
      }
    });
  });
};
